import React from "react";
import { useLocation } from "react-router-dom";
import { useJstReveal } from "../../hooks/useJstReveal";
import { JstShellContext } from "../../context/JstShellContext";

/**
 * Outer wrapper for most routes: full-height column + optional depth CTA (via Footer).
 * The previous top WebGL hero band was removed—it sat above the header and read as dead space.
 */
export default function LazyPageShell({ children, pathname: pathnameProp }) {
  const location = useLocation();
  const pathname = pathnameProp ?? location.pathname ?? "/";
  useJstReveal([pathname]);

  const showDepthCta = pathname !== "/contact" && pathname !== "/email";

  return (
    <JstShellContext.Provider value={{ showDepthCta }}>
      <div className="jst-page-shell">
        <div className="jst-shell-children">{children}</div>
      </div>
    </JstShellContext.Provider>
  );
}
